export enum CASE_CODE {
	CREATEOTP = 'MBR-OTP',
	CREATEREGISTRATION = 'MBR-REGISTRATION',
	CREATERECOVERUSERNAME = 'MBR-RECOVER-USERNAME',
	NOTIFYEMPLOYER = 'MBR-NOTIFY-EMPLOYER',
	DIRECTDEBIT = 'MBR-DIRECT_DEBIT',
}
